const KEY = (templateId) => `shake:drafts:${templateId}`;

export function getDrafts(templateId) {
  try {
    const raw = localStorage.getItem(KEY(templateId));
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function saveDraft(templateId, draft) {
  const now = new Date().toISOString();
  const withMeta = {
    ...draft, // { id?, name, formats, fields (our FormValues) }
    id: draft.id || `${now}-${Math.random().toString(36).slice(2, 8)}`,
    status: 'draft',
    savedAt: now,
    template_id: templateId,
  };

  const current = getDrafts(templateId).filter((d) => d.id !== withMeta.id);
  localStorage.setItem(KEY(templateId), JSON.stringify([withMeta, ...current]));
  return withMeta;
}

export function removeDraft(templateId, draftId) {
  const current = getDrafts(templateId).filter((d) => d.id !== draftId);
  localStorage.setItem(KEY(templateId), JSON.stringify(current));
  return true;
}